import { Button, DialogActions, DialogContent, Divider, Link, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { applicationSlice } from '../../../redux/ApplicationSlice';
import { ApplicationActions } from '../../../utils/constants';

const { UPDATE_FIRMWARE_CONFIRMATION_DIALOG } = ApplicationActions.Dialogs;

const OptionalFirmwareUpdateDialog = ({ onClose }) => {
  const dispatch = useDispatch();

  const handleCloseAndContinue = () => {
    onClose();
    dispatch(applicationSlice.actions.onOpenDialog(UPDATE_FIRMWARE_CONFIRMATION_DIALOG));
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <DialogTitle variant="sectionTitle" align="center">
        <Trans i18nKey="optionalFirmwareDialog.title">Optional Firmware Update</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap">
          <Typography variant="body1">
            <Trans i18nKey="optionalFirmwareDialog.text1">Your robot is eligible for an optional firmware update.</Trans>
          </Typography>
          <Typography variant="body1">
            <Trans i18nKey="optionalFirmwareDialog.text2">
              Firmware updates require a stable Bluetooth connection between your robot and your device. Your robot should be fully charged before
              starting an update.
            </Trans>
          </Typography>
          <Typography variant="body1">
            <Trans i18nKey="optionalFirmwareDialog.text3">
              Before you proceed, please visit the link below for additional information about firmware updates.
            </Trans>
          </Typography>
          <Link
            href="https://sphero.com/pages/support?hcUrl=%2Fsphero-edu-firmware-updates-244676"
            align="center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans i18nKey="learn.more">Learn More</Trans>
          </Link>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ justifyContent: 'center', margin: '2px 0' }}>
        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          <Button variant="text" autoFocus onClick={handleClose}>
            <Trans i18nKey="button.cancel">Cancel</Trans>
          </Button>
          <Button variant="contained" autoFocus onClick={handleCloseAndContinue}>
            <Trans i18nKey="button.ok">OK</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};

OptionalFirmwareUpdateDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default OptionalFirmwareUpdateDialog;
